import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { try_for_free } from "../../url";
import RefSiteFooter from "./RefSiteFooter";
import logo from "../../Assets/logo.png";
import thanks from "../../Assets/thanks.svg";
import play_icon_transparent_new from "../../Assets/play_icon_transparent_new.PNG";
import requireSign_video from "../../Assets/requireSign_video.mp4";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";

const WAITING_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
  :root {
    --rsw-ink: #163A5A; --rsw-ink2: #3D6A8C; --rsw-ink3: #5E87A3;
    --rsw-sky: #1A63A5; --rsw-mint: #2AB6E8;
    --rsw-secondary: #2AB6E8;
    --rsw-secondary-deep: #1AA3D4;
    --rsw-secondary-soft: #D9F4FC;
    --rsw-bg-dark: #0E2D48;
    --rsw-white: #FFFFFF; --rsw-surface: #F5F9FC;
    --rsw-ff-head: 'Plus Jakarta Sans', system-ui, sans-serif; --rsw-ff-body: 'Plus Jakarta Sans', system-ui, sans-serif;
  }
  .rsw-page { 
    font-family: var(--rsw-ff-body); color: var(--rsw-ink); 
    background: linear-gradient(180deg, #E8F4FC 0%, #fff 100%);
    min-height: 100vh; display: flex; flex-direction: column;
  }

  .rsw-hero {
    flex: 1; display: flex; align-items: center; justify-content: center;
    padding: 80px 40px; position: relative; overflow: hidden;
  }
  .rsw-hero-bg {
    position: absolute; top: -100px; right: -100px;
    width: 600px; height: 600px; border-radius: 50%;
    background: radial-gradient(circle, rgba(26,99,165,.08) 0%, transparent 70%);
    pointer-events: none;
  }

  .rsw-container { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: 1.2fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 2; }

  .rsw-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    background: linear-gradient(135deg, var(--rsw-sky-light) 0%, var(--rsw-secondary-soft) 100%);
    color: var(--rsw-sky); border: 1px solid rgba(26,99,165,.15);
    font-size: 12px; font-weight: 600; padding: 8px 16px;
    border-radius: 100px; margin-bottom: 24px; letter-spacing: .06em;
  }
  .rsw-h1 { font-family: var(--rsw-ff-head); font-size: 64px; font-weight: 800; letter-spacing: -.03em; line-height: 1; margin-bottom: 24px; }
  .rsw-h1-grad { background: linear-gradient(135deg, var(--rsw-sky), var(--rsw-mint)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  
  .rsw-sub { font-size: 19px; color: var(--rsw-ink2); line-height: 1.6; margin-bottom: 40px; font-weight: 400; }
  
  .rsw-signup-box { 
    background: #fff; border: 1px solid #E0E3EF; padding: 8px; border-radius: 16px; 
    display: flex; gap: 10px; box-shadow: 0 12px 32px rgba(22,58,90,.08);
    max-width: 480px; margin-bottom: 20px;
  }
  .rsw-input { flex: 1; border: none; outline: none; padding: 0 16px; font-family: var(--rsw-ff-body); font-size: 15px; color: var(--rsw-ink); }
  .rsw-btn { 
    background: var(--rsw-sky); color: #fff; border: none; padding: 12px 24px; 
    border-radius: 10px; font-weight: 600; cursor: pointer; transition: all .2s; 
  }
  .rsw-btn:hover { background: var(--rsw-secondary-deep); transform: translateY(-1px); }

  .rsw-thanks-note { display: flex; align-items: center; gap: 12px; font-size: 14px; color: var(--rsw-ink3); }
  .rsw-thanks-img { height: 28px; width: auto; }

  /* VIDEO PREVIEW */
  .rsw-video-card { 
    position: relative; border-radius: 24px; overflow: hidden; 
    cursor: pointer; box-shadow: 0 32px 80px rgba(22,58,90,.18);
    aspect-ratio: 16/9; background: #000;
  }
  .rsw-video-img { width: 100%; height: 100%; object-fit: cover; opacity: 0.8; transition: transform .5s; }
  .rsw-video-card:hover .rsw-video-img { transform: scale(1.05); }
  .rsw-play-btn { 
    position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
    width: 80px; height: 80px; background: rgba(255,255,255,.95); border-radius: 50%;
    display: flex; align-items: center; justify-content: center; color: var(--rsw-sky);
    box-shadow: 0 0 0 0 rgba(255,255,255,0.4); animation: rsw-pulse-btn 2s infinite;
  }
  @keyframes rsw-pulse-btn {
    0% { box-shadow: 0 0 0 0 rgba(255,255,255,0.7); }
    70% { box-shadow: 0 0 0 20px rgba(255,255,255,0); }
    100% { box-shadow: 0 0 0 0 rgba(255,255,255,0); }
  }

  /* MODAL */
  .rsw-modal-overlay { 
    position: fixed; top: 0; left: 0; right: 0; bottom: 0; 
    background: rgba(14,45,72,.95); z-index: 1000; 
    display: flex; align-items: center; justify-content: center; padding: 40px;
  }
  .rsw-modal-content { position: relative; width: 100%; max-width: 1000px; border-radius: 20px; overflow: hidden; background: #000; }
  .rsw-modal-close { 
    position: absolute; top: 20px; right: 20px; z-index: 10;
    width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,.1);
    border: none; color: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all .2s;
  }
  .rsw-modal-close:hover { background: rgba(255,255,255,.2); transform: rotate(90deg); }

  @media (max-width: 1024px) {
    .rsw-container { grid-template-columns: 1fr; gap: 48px; text-align: center; }
    .rsw-h1 { font-size: 52px; }
    .rsw-signup-box { margin-left: auto; margin-right: auto; }
    .rsw-thanks-note { justify-content: center; }
  }
  @media (max-width: 600px) {
    .rsw-h1 { font-size: 40px; }
    .rsw-signup-box { flex-direction: column; padding: 12px; }
    .rsw-btn { width: 100%; }
    .rsw-hero { padding: 40px 24px; }
  }
`;

function RefWaitingList() {
  const { t } = useTranslation('waitingList');
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const year = new Date().getFullYear();

  const handleJoin = (e) => {
    e.preventDefault();
    if (email) {
      window.location.href = `${try_for_free}?prefilled_email=${email}`;
    }
  };

  return (
    <div className="rsw-page">
      <style>{WAITING_STYLES}</style>
      
      <div className="rsw-hero">
        <div className="rsw-hero-bg" />
        <div className="rsw-container">
          <div className="rsw-text">
            <div className="rsw-eyebrow">{t('eyebrow')}</div>
            <h1 className="rsw-h1">
              {t('titlePrefix')}<span className="rsw-h1-grad">{t('titleHighlight')}</span>{t('titleSuffix')}
            </h1>
            <p className="rsw-sub">
              {t('description', { year })}
            </p>

            <form className="rsw-signup-box" onSubmit={handleJoin}>
              <input 
                className="rsw-input" 
                type="email" 
                placeholder={t('placeholder')}
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="rsw-btn" type="submit">{t('button')}</button>
            </form>

            <div className="rsw-thanks-note">
              <span>{t('thanksNote')}</span>
              <img src={thanks} alt="Thanks" className="rsw-thanks-img" />
            </div>
          </div>

          <div className="rsw-video-preview">
            <div className="rsw-video-card" onClick={() => setOpen(true)}>
              <img src={play_icon_transparent_new} alt={t('videoAlt')} className="rsw-video-img" />
              <div className="rsw-play-btn">
                <PlayArrowIcon sx={{ fontSize: 40 }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <div className="rsw-modal-overlay" onClick={() => setOpen(false)}>
          <div className="rsw-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="rsw-modal-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </button>
            <video controls autoPlay style={{ width: "100%", display: "block" }}>
              <source src={requireSign_video} type="video/mp4" />
            </video>
          </div>
        </div>
      )}

      <RefSiteFooter />
    </div>
  );
}

export default RefWaitingList;
